import React from 'react'

import checkmark from '../../../assets/imgs/buttons/checkmark-circle.svg'
import './job-description-box.scss'

const JobDescriptionItem = (props) => {
  const { description } = props
  return (
    <div className="job-description-item">
      <img alt="check" src={checkmark} />
      <p className="text__container padding__pl-10">{description}</p>
    </div>
  )
}
export default JobDescriptionItem
